import React from 'react'
import PropTypes from 'prop-types'

import styles from './iconFooter.module.scss'

const icons = [
  {
    src: '/static/img/inquiry/exclusive_airfare.svg',
    alt: 'exclusive_airfare',
    label: 'Exclusive Airfares',
  },
  {
    src: '/static/img/inquiry/safe_secure.svg',
    alt: 'safe_secure',
    label: '100% Safe & Secure',
  },
  {
    src: '/static/img/inquiry/live_agents.svg',
    alt: 'live_agents',
    label: 'Live Travel Agents',
  },
]

const IconFooter = ({ className = '', semiBold, location, ...rest }) => {
  const wrapperStyles = `${className} ${location && styles[`${location}`]} `

  return (
    <section className={wrapperStyles} {...rest}>
      <div className={`${styles.iconFooter__icons} ${semiBold ? styles.semiBold : null}`}>
        {icons.map((i, idx) => (
          <div key={idx}>
            <img src={i.src} alt={i.alt} />
            <p>{i.label}</p>
          </div>
        ))}
      </div>
    </section>
  )
}

IconFooter.propTypes = {
  className: PropTypes.string,
}

export { IconFooter }
